function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.49563 13.9999C11.9809 13.9999 13.9956 11.9852 13.9956 9.49993C13.9956 7.01465 11.9809 4.99993 9.49563 4.99993C7.01034 4.99993 4.99563 7.01465 4.99563 9.49993C4.99563 11.9852 7.01034 13.9999 9.49563 13.9999ZM9.49563 12.0035C8.11293 12.0035 6.99204 10.8826 6.99204 9.49993C6.99204 8.11723 8.11293 6.99634 9.49563 6.99634C10.8783 6.99634 11.9992 8.11723 11.9992 9.49993C11.9992 10.8826 10.8783 12.0035 9.49563 12.0035Z",
  fill: "#2E4768"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.764 11.5782C20.0569 5.78462 15.4972 0 9.49203 0C3.48852 0 -1.07157 5.79256 0.220194 11.5789C1.21726 16.2785 5.24923 20.843 7.65563 23.2233C8.68623 24.2428 10.2978 24.2428 11.3284 23.2233C13.735 20.8429 17.7672 16.278 18.764 11.5782ZM9.49203 2C14.2045 2 17.8288 6.58627 16.812 11.1426C16.3237 13.3319 15.2279 15.298 13.9422 17.1155C12.5984 19.0149 11.075 20.6609 9.92194 21.8014C9.67059 22.0501 9.31347 22.0501 9.06212 21.8014C7.90916 20.661 6.38583 19.015 5.04212 17.1157C3.75622 15.2982 2.66089 13.3325 2.17215 11.1432C1.15641 6.59328 4.78215 2 9.49203 2Z",
  fill: "#2E4768"
});

var SvgMarkVacancy = function SvgMarkVacancy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarkVacancy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/markVacancy.3cad0691.svg";
export { ForwardRef as ReactComponent };